/* eslint-disable prettier/prettier */
import Vue from "vue";
import Vuex from "vuex";
import router from "../router/index.js";
const Dossiers = {
    namespaced: true,
    state: {
        dossiers: [],
        dossiersDelayManager: [],
        dossiersDelayTicketOffice: [],
        features: [],
        managers: [],
        point: [],
        dossierSelected: {
            wayType: null,
            wayNum: null,
            milestoneStart1: null,
            milestoneStart2: null,
            milestoneEnd1: null,
            milestoneEnd2: null,
            type: [],
            extraUrban: true,
            intraUrban: true,
            urbanDocument: null,
            sections: null,
            plotNumbers: null,
            place: null,
            dateStart: null,
            numberDays: null,
            petitionerId: null,
            cerfa1402301Id: null,
            cerfa1402401Id: null,
            beneficiaryId: null,
            addressCity: null,
            addressExt: null,
            addressName: null,
            addressNum: null,
            showComboOperator: false,
            queryOperator: '',
            isFavorable: null,
            addressPostalCode: null,
            addressType: null,
            lat: null,
            lon: null,
            operationCode: null,
            caseNumbers: null,
            theGeom: null,
            operatorPerimeterId: null,
            operator: null,

        },
        pagination: {
            current: 1,
            totalCount: 1,
            numItemsPerPage: 50
        }
    },
    actions: {
        addDossier(context, request) {
            return new Promise((resolve, reject) => {
                Vue.axios.post(window.urlapi + "request", request).then(
                    response => {
                        if (response.data.success) {
                            resolve(response.data.data);
                        } else {
                            resolve(null);
                        }
                    },
                );
            })
        },

        deleteDossier(context, id) {
            Vue.axios.delete(window.urlapi + "request/" + id).then(
                response => {
                    if (response.data.success == true) {
                        Vue.prototype.$awn.success(
                            response.data.message.toString()
                        );

                        context.commit("DELETEREQUEST", id);
                    }
                },
            );
        },

        setDossier(context, request) {
            return new Promise((resolve, reject) => {
                request.showComboOperator = false;
                request.queryOperator = '';
                request.isFavorable = null;
                context.commit("SETDOSSIER", request);
                resolve();
            })
        },
        initDossier(context) {
            return new Promise((resolve, reject) => {
                let request = {
                    wayType: null,
                    type: [],
                    wayNum: null,
                    milestoneStart1: null,
                    milestoneStart2: null,
                    milestoneEnd1: null,
                    milestoneEnd2: null,
                    extraUrban: true,
                    isFavorable: null,
                    intraUrban: true,
                    urbanDocument: null,
                    sections: null,
                    plotNumbers: null,
                    place: null,
                    dateStart: null,
                    numberDays: null,
                    petitionerId: null,
                    cerfa1402301Id: null,
                    cerfa1402401Id: null,
                    beneficiaryId: null,
                    addressCity: null,
                    addressExt: null,
                    addressName: null,
                    showComboOperator: false,
                    queryOperator: '',
                    addressNum: null,
                    addressPostalCode: null,
                    addressType: null,
                    lat: null,
                    lon: null,
                    operationCode: null,
                    caseNumbers: null,
                    theGeom: null,
                    operatorPerimeterId: null,
                    operator: {},
                };
                context.commit("SETDOSSIER", request);
                resolve();
            })
        },
        getDossierDelaysManager(context) {
            let sort = '?searchSort=depositDate';
            let delays = "&delayManager=" + true;

            let page = "&offset=0";
            let numItemsPerPage = "&numItemsPerPage=50";
            let searchDir = "&searchDir=DESC";
            let searchFilter = "&searchFilter={}";

            Vue.axios.get(window.urlapi + "request" + sort + delays + page + numItemsPerPage + searchDir + searchFilter).then(
                response => {
                    context.commit("GETDOSSIERSDELAYMANAGER", response.data.data);
                },
            );
        },
        getDossierDelaysTicketOffice(context) {
            let sort = '?searchSort=depositDate';
            let delays = "&delayTicketOffice=" + true;

            let page = "&offset=0";
            let numItemsPerPage = "&numItemsPerPage=50";
            let searchDir = "&searchDir=DESC";
            let searchFilter = "&searchFilter={}";

            Vue.axios.get(window.urlapi + "request" + sort + delays + page + numItemsPerPage + searchDir + searchFilter).then(
                response => {
                    context.commit("GETDOSSIERSDELAYTICKETOFFICE", response.data.data);
                },
            );
        },
        getDossiers(context, pagination) {
            let page = "?offset=" + pagination.offset;
            let numItemsPerPage = "&numItemsPerPage=" + pagination.numItemsPerPage;

            let searchText = "&searchText=" + pagination.searchText;
            let searchFilter = "&searchFilter=" + JSON.stringify(pagination.searchFilter);

            let searchSort = "&searchSort=" + pagination.searchSort;
            let searchDir = "&searchDir=" + pagination.searchDir;

            Vue.axios.get(window.urlapi + "request" + page + numItemsPerPage + searchText + searchSort + searchDir + searchFilter).then(
                response => {
                    context.commit("GETDOSSIERS", response.data.data);
                    context.commit("GETFEATURES", response.data.features);
                    context.commit("SETPAGINATION", response.data.pagination);
                },
            );
        },
        initPoint(context) {
            return new Promise((resolve, reject) => {
                let firstAddress = {
                    geometry: {
                        type: "Point",
                        coordinates: [5.330961, 43.491699],
                    },
                    type: "Feature",
                    properties: {},
                };
                context.commit("GETPOINT", firstAddress);
                resolve();
            })
        },
        getDossier(context, id) {
            return new Promise((resolve, reject) => {
                Vue.axios.get(window.urlapi + "request/" + id).then(
                    response => {
                        response.data.data.point = response.data.extra
                        response.data.data.type = [];
                        if (response.data.data.cerfa1402301 != null) {
                            response.data.data.type.push("cerfa14023");
                        }
                        if (response.data.data.cerfa1402401 != null) {
                            response.data.data.type.push("cerfa14024");
                        }
                        context.commit("GETDOSSIER", response.data.data);
                        context.commit("GETFEATURES", response.data.features);
                        context.commit("GETPOINT", response.data.extra);
                        resolve();
                    },
                );
            })
        },
        updateDossier(context, dossier) {
            return new Promise((resolve, reject) => {
                Vue.axios.put(window.urlapi + "request/" + dossier.id, dossier).then(
                    response => {
                        if (response.data.success == true) {
                            Vue.prototype.$awn.success(
                                response.data.message.toString()
                            );
                        }
                        context.commit("GETDOSSIER", response.data.data);
                        resolve(response.data.success);
                    },
                );
            })
        },
        sendRenew(context, params) {
            return new Promise((resolve, reject) => {
                Vue.axios.post(window.urlapi + "request/renew/" + params.request.id, params).then(
                    response => {
                        if (response.data.success == true) {
                            Vue.prototype.$awn.success(
                                response.data.message.toString()
                            );
                            resolve(response.data.data);
                        }
                    },
                );
            })
        },
        sendDuplicate(context, params) {
            return new Promise((resolve, reject) => {
                Vue.axios.post(window.urlapi + "request/duplicate/" + params.id).then(
                    response => {
                        if (response.data.success == true) {
                            Vue.prototype.$awn.success(
                                response.data.message.toString()
                            );
                            resolve(response.data.data);
                        }
                    },
                );
            })
        },
        getManagers(context, id) {
            Vue.axios.get(window.urlapi + "request/" + id + "/managers").then(
                response => {
                    context.commit("GETMANAGERS", response.data.data);
                },
            );
        },
        setDossier(context, pagination) {
            context.commit("SETPAGINATION", pagination);
        }
    },
    mutations: {

        SETPAGINATION: (state, pagination) => {
            state.pagination = pagination;
        },
        SETDOSSIER: (state, dossier) => {
            state.dossierSelected = dossier
        },
        SETPAGINATION: (state, pagination) => {
            state.pagination = pagination;
        },
        GETDOSSIERS: (state, dossiers) => {
            state.dossiers = dossiers;
        },
        GETDOSSIERSDELAYMANAGER: (state, dossiers) => {
            state.dossiersDelayManager = dossiers;
        },
        GETDOSSIERSDELAYTICKETOFFICE: (state, dossiers) => {
            state.dossiersDelayTicketOffice = dossiers;
        },
        GETPOINT: (state, point) => {
            state.point = Object.freeze(point);
        },
        GETFEATURES: (state, features) => {
            state.features = Object.freeze(features);
        },
        DELETEREQUEST: (state, id) => {
            let toDelete = state.dossiers.findIndex(item => item.state.id === id);
            state.dossiers.splice(toDelete, 1);
        },
        GETDOSSIER: (state, dossier) => {
            dossier.stateId = dossier.state.id;

            if (dossier.managerPerimeter === null)
                dossier.managerPerimeterId = null;
            else
                dossier.managerPerimeterId = dossier.managerPerimeter.id;

            state.dossierSelected = dossier;
        },
        GETMANAGERS: (state, managers) => {
            state.managers = managers;
        }
    },
    getters: {

        pagination: state => {
            return state.pagination;
        },
        point: state => {
            return state.point;
        },
        dossiers: state => {
            return state.dossiers;
        },
        dossiersDelayManager: state => {
            return state.dossiersDelayManager;
        },
        dossiersDelayTicketOffice: state => {
            return state.dossiersDelayTicketOffice;
        },
        features: state => {
            return state.features;
        },
        countdossiers: state => {
            return state.dossier.length;
        },
        dossierSelected: state => {
            return state.dossierSelected;
        },
        managers: state => {
            return state.managers;
        }
    },
    modules: {}
};

export default Dossiers;